var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33325 5.49992H5.49992V4.58325H3.66659V7.33325H18.3333V4.58325H16.4999V5.49992H14.6666V4.58325H7.33325V5.49992ZM18.3333 9.16658H3.66659V18.3333H18.3333V9.16658ZM14.6666 2.74992H7.33325V1.83325H5.49992V2.74992H3.66659C2.65406 2.74992 1.83325 3.57073 1.83325 4.58325V18.3333C1.83325 19.3458 2.65406 20.1666 3.66659 20.1666H18.3333C19.3458 20.1666 20.1666 19.3458 20.1666 18.3333V4.58325C20.1666 3.57073 19.3458 2.74992 18.3333 2.74992H16.4999V1.83325H14.6666V2.74992ZM6.41658 12.8333V10.9999H8.24992V12.8333H6.41658ZM10.0833 12.8333H11.9166V10.9999H10.0833V12.8333ZM13.7499 12.8333V10.9999H15.5833V12.8333H13.7499ZM6.41658 14.6666V16.4999H8.24992V14.6666H6.41658ZM11.9166 16.4999H10.0833V14.6666H11.9166V16.4999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.523f8431c1bde3cf1d438b73dc7e37b5.svg";
export { ForwardRef as ReactComponent };